import { SERVERS_HOST_LIST} from "@/config";


export const initRegion = () => {
    return SERVERS_HOST_LIST[0]
    // if (localStorage['region'] && COUNTRIES_SNG.includes(localStorage['region'])) {
    //     return SERVERS_HOST_LIST[0]
    // } else if (!localStorage['region']) {
    //     return SERVERS_HOST_LIST[0]
    // } else {
    //     return SERVERS_HOST_LIST[1]
    // }
}